/**
 * Marca do Code Manager: três painéis empilhados, um por agente, na cor de
 * cada um. É a mesma ideia do ícone do app desktop — a grade de panes é o que
 * o produto faz, então é o que a marca mostra.
 *
 * As cores vêm dos tokens, não de hex literal. A moldura era um cinza escuro
 * fixo, que fica invisível sobre um tema claro. `fill` e `stroke` aceitam
 * `var()` nos três motores, então a marca acompanha o tema de graça.
 */
export function BrandMark({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <rect x="2" y="3" width="20" height="5.4" rx="1.6" fill="none" stroke="var(--border-strong)" />
      <rect x="2" y="9.3" width="20" height="5.4" rx="1.6" fill="none" stroke="var(--border-strong)" />
      <rect x="2" y="15.6" width="20" height="5.4" rx="1.6" fill="none" stroke="var(--border-strong)" />
      <circle cx="5.4" cy="5.7" r="1.25" fill="var(--claude)" />
      <circle cx="5.4" cy="12" r="1.25" fill="var(--codex)" />
      <circle cx="5.4" cy="18.3" r="1.25" fill="var(--gemini)" />
      <rect x="8.4" y="5.1" width="9.5" height="1.2" rx="0.6" fill="var(--text-faint)" />
      <rect x="8.4" y="11.4" width="6.5" height="1.2" rx="0.6" fill="var(--text-faint)" />
      <rect x="8.4" y="17.7" width="11" height="1.2" rx="0.6" fill="var(--text-faint)" />
    </svg>
  );
}
